module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.avatarClass,
    style: (_vm.avatarStyle)
  }, [(_vm.src) ? _c('img', {
    attrs: {
      "alt": "",
      "src": _vm.src
    }
  }) : (_vm.iconName) ? _c('rt-icon', {
    attrs: {
      "name": _vm.iconName,
      "color": _vm.iconColor,
      "size": _vm.computedIconSize
    }
  }) : _c('span', {
    style: (_vm.textStyle)
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("badge", function() {
    return [(_vm.badgeText) ? _c('rt-badge', {
      attrs: {
        "value": _vm.badgeText,
        "type": _vm.type
      }
    }) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de84389a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/avatar/rtAvatar.vue
// module id = 2162
// module chunks = 228